// v4 — Efficiency Ratio (MER)
import React from 'react';
import { v4data, GOALS, sumRange } from './v4data';
import { AreaChart, Spark } from './viz';
import { PageHeader, DatePill, Card, Insight, Delta, fmtX, pct } from './v4ui';
import MarkPopup from './MarkPopup';
import './dashboard.scss';

export default function MerV4() {
  const D = v4data(30);
  const today = D.to;
  const [yy, mm] = today.split('-');
  const first = D.dates[0];
  const clamp = (s) => (s < first ? first : s);
  const win = (f) => sumRange(D.ds.accountDaily, clamp(f), today).roas;
  const qStart = String(Math.floor((parseInt(mm) - 1) / 3) * 3 + 1).padStart(2, '0');

  const mer = D.cur.roas;
  const merPrev = D.prev.roas;
  const periods = [
    { l: '7 days', v: win(D.dates[Math.max(0, D.last - 6)]) },
    { l: '30 days', v: mer },
    { l: 'MTD', v: win(`${yy}-${mm}-01`) },
    { l: 'QTD', v: win(`${yy}-${qStart}-01`) },
    { l: 'YTD', v: win(`${yy}-01-01`) },
  ];
  const predicted = mer * 1.04;

  return (
    <div className="v4-dash">
      <PageHeader title="Efficiency Ratio" sub="Marketing Efficiency Ratio — blended revenue ÷ ad spend" live right={<DatePill />} />

      <MarkPopup inline context="mer" />

      <section className="v4-secrow">
        <Card title="MER Trend" sub="Blended, daily · trailing 30 days"
          right={<div className="v4-hero-num"><span className="n">{fmtX(mer)}</span><Delta value={pct(mer, merPrev)} /></div>}>
          <AreaChart height={300} labels={D.dayLabels} series={[{ name: 'MER', color: '#8AE8BD', data: D.daily.map((d) => d.totals.roas) }]} />
          {(() => { const diff = (mer / GOALS.mer - 1) * 100; const near = Math.abs(diff) < 0.75; return (
          <div className="v4-goal-note">Goal: <b>{GOALS.mer.toFixed(1)}x</b> · you're running <b style={{ color: diff >= -0.75 ? '#8AE8BD' : '#fbbf24' }}>{near ? 'right on target' : `${Math.abs(diff).toFixed(0)}% ${diff >= 0 ? 'above' : 'below'} target`}</b></div>
          ); })()}
        </Card>

        <div className="v4-side">
          <Card title="By Period">
            <ul className="v4-period-list">
              {periods.map((p) => (
                <li key={p.l}>
                  <span className="pl">{p.l}</span>
                  <span className="pv" style={{ color: p.v >= GOALS.mer ? '#8AE8BD' : '#fbbf24' }}>{fmtX(p.v)}</span>
                  <span className="pd"><Spark data={D.daily.slice(-14).map((d) => d.totals.roas)} color={p.v >= GOALS.mer ? '#8AE8BD' : '#fbbf24'} w={60} h={22} fill={false} /></span>
                </li>
              ))}
            </ul>
          </Card>
          <Card title="Predicted MER" sub="Next 7 days">
            <div className="v4-mer-big"><span className="n" style={{ color: '#7A75F6' }}>{fmtX(predicted)}</span><span className="v4-delta up">▲ on track</span></div>
          </Card>
        </div>
      </section>

    </div>
  );
}
